import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_LINK } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-black">
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 h-20 flex items-center justify-between gap-4">
          <Link
            to="/"
            data-testid="nav-logo-link"
            className="flex items-center gap-3 shrink-0"
            onClick={() => setOpen(false)}
          >
            <img
              src="/logo-nav.png"
              alt="Quercy Nuisibles"
              className="h-14 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={link.testId}
                className={({ isActive }) =>
                  `text-sm font-semibold uppercase tracking-[0.15em] transition-colors duration-300 hover:text-[#E50914] ${
                    isActive ? "text-[#E50914]" : "text-black"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={PHONE_LINK}
              data-testid="nav-phone-button"
              className="hidden md:inline-flex items-center gap-2 bg-black text-white px-5 py-3 text-sm font-semibold uppercase tracking-[0.1em] transition-colors duration-300 hover:bg-[#E50914]"
            >
              <Phone className="h-4 w-4" />
              {PHONE_DISPLAY}
            </a>
            <button
              data-testid="nav-menu-toggle"
              onClick={() => setOpen(!open)}
              className="lg:hidden inline-flex items-center justify-center h-11 w-11 border border-black bg-white text-black transition-colors duration-300 hover:bg-black hover:text-white"
              aria-label="Menu"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-40 bg-white pt-20 lg:hidden"
            data-testid="mobile-menu"
          >
            <nav className="flex flex-col px-6 py-10 gap-2">
              {NAV_LINKS.map((link, i) => (
                <motion.div
                  key={link.to}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.08 + i * 0.06, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                >
                  <NavLink
                    to={link.to}
                    data-testid={`mobile-${link.testId}`}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `font-display uppercase text-5xl tracking-tight leading-tight block py-2 transition-colors duration-300 ${
                        isActive ? "text-[#E50914]" : "text-black"
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                </motion.div>
              ))}
              <motion.a
                href={PHONE_LINK}
                data-testid="mobile-phone-button"
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="mt-8 inline-flex items-center justify-center gap-3 bg-black text-white px-6 py-4 font-semibold uppercase tracking-[0.1em]"
              >
                <Phone className="h-5 w-5" />
                {PHONE_DISPLAY}
              </motion.a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
